import React from 'react';
import {
  Box,
  TextField,
  FormControlLabel,
  Switch,
  Typography
} from '@mui/material';
import { FormData } from '../FormBuilder';

interface BasicInfoStepProps {
  formInfo: FormData;
  onChange: (formInfo: FormData) => void;
}

const BasicInfoStep: React.FC<BasicInfoStepProps> = ({ formInfo, onChange }) => {
  const handleChange = (field: keyof FormData, value: any) => {
    onChange({
      ...formInfo,
      [field]: value
    });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Información Básica del Formulario
      </Typography>
      <Typography variant="body2" color="textSecondary" paragraph>
        Complete la información general del formulario. Los campos marcados con * son obligatorios.
      </Typography>

      <Box display="flex" flexDirection="column" gap={3} mt={3}>
        <TextField
          label="Nombre del Formulario"
          value={formInfo.nombre}
          onChange={(e) => handleChange('nombre', e.target.value)}
          required
          fullWidth
          helperText="Nombre descriptivo del formulario (ej: Auditoría de Seguridad Industrial)"
        />

        <TextField
          label="Descripción"
          value={formInfo.descripcion}
          onChange={(e) => handleChange('descripcion', e.target.value)}
          multiline
          rows={4}
          fullWidth
          helperText="Descripción detallada del propósito y alcance del formulario"
        />

        <Box display="flex" gap={2}>
          <FormControlLabel
            control={
              <Switch
                checked={formInfo.es_template}
                onChange={(e) => handleChange('es_template', e.target.checked)}
                color="primary"
              />
            }
            label="Es una plantilla"
          />
          <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
            Las plantillas pueden ser reutilizadas para crear nuevos formularios
          </Typography>
        </Box>

        {formInfo.version && (
          <Box sx={{ p: 2, bgcolor: 'info.light', borderRadius: 1 }}>
            <Typography variant="body2">
              <strong>Versión actual:</strong> {formInfo.version}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Al guardar cambios en un formulario publicado, se creará una nueva versión automáticamente
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default BasicInfoStep;
